var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmailFilled = function SvgEmailFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M4.8 4.25A2.543 2.543 0 0 0 2.25 6.8c0 .034.002.067.007.1a.757.757 0 0 0-.007.1v10A2.756 2.756 0 0 0 5 19.75h14A2.756 2.756 0 0 0 21.75 17V7a.767.767 0 0 0-.007-.1.767.767 0 0 0 .007-.1 2.543 2.543 0 0 0-2.55-2.55H4.8ZM3.75 7.368V9.39l4.563 3.053-4.563 4.58A1.256 1.256 0 0 0 5 18.25h.019l4.704-4.917c1.518.778 3.253.89 4.771 0l4.69 4.903a1.257 1.257 0 0 0 1.066-1.227l-4.346-4.453 4.346-3.033V7.37l-6.19 4.408c-1.193.778-2.71.778-4.012 0L3.75 7.368Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmailFilled);
export default ForwardRef;